module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA11.f69ca70a.jpg";